export default "__VITE_PUBLIC_ASSET__2c021602__"